export default function ChevronRight() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="button__arrow" width="24" height="24" viewBox="0 0 24 24">
            <g id="Group_645" data-name="Group 645" transform="translate(0 23.976) rotate(-90)">
                <rect id="Rectangle_342" data-name="Rectangle 342" width="24" height="24" transform="translate(-0.024)" fill="none"/>
                <path id="Path_155" data-name="Path 155" d="M12.219,15,7.757,10.757,9.245,9.343l2.974,2.829,2.974-2.829,1.488,1.414Z" transform="translate(-0.467 1)" fill="#fff"/>
            </g>
        </svg>
    )
}